module.exports = __webpack_public_path__ + "img/right-from-bracket-solid.34584ff1.svg";